import React from 'react';

/** Prevents overlapping async actions; exposes key for per-button spinners. */
export function usePendingAction() {
  const pendingRef = React.useRef<string | null>(null);
  const [pendingKey, setPendingKey] = React.useState<string | null>(null);

  const isPending = pendingKey != null;
  const isKey = (key: string) => pendingKey === key;

  const run = React.useCallback(async (key: string, fn: () => Promise<void>) => {
    if (pendingRef.current) return;
    pendingRef.current = key;
    setPendingKey(key);
    try {
      await fn();
    } finally {
      pendingRef.current = null;
      setPendingKey(null);
    }
  }, []);

  return { pendingKey, isPending, isKey, run };
}

export function InlineSpinner({ tone = 'light' }: { tone?: 'light' | 'dark' }) {
  return React.createElement('span', {
    className: `gm-inline-spinner is-${tone}`,
    'aria-hidden': true,
  });
}
